<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 class="font-family005">Solutions</h2>
            <ul class="font-family005">
                <li><a routerLink="/"><i class="bx bx-home"></i> Home</a></li>
                <li class="active">Solutions / Smart card solutions</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Details Area -->
<section class="services-details-area pt-5 pb-70">
    <div class="container">
        <div class="row match-height">
            <div class="col-lg-6 col-12">
                <div class="services-details-content">
                    <div class="services-content">
                        <div class="row match-height">
                            <div class="col-12 pb-2">
                                <div class="fix">
                                    <img src="assets/img/services/smcity.png" alt="Image" class="img-fluid">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-12">
                <div class="services-details-content">
                    <h2  class="font-family005">Smart City and Safe City</h2>
                    <div class="services-content font-family004">
                        <p>BonTon Softwares Framework enables Cities to Build a City Level Digital Platform that can integrate City Data from various connected systems from across different departments and functions of the city and integrating all the information and actionable items onto a single City Operations Platform. Our platform provides rich visualisation , user friendly controls , graphical user interface and geospatial representation.</p>
                    </div>
                    <div class="services-content">
                        <h3 class="font-family005">Smart City Initiative</h3>
                        <p class="font-family004">Smart city initiative is a revolutionary project initiated by the Government of India to transform the country’s urban landscape. We had the opportunity to provide our services to the smart cities initiative in Coimbatore and Vellore through the mission directorate for the implementation of smart cities in the state of Tamil Nadu under TUFIDCO (Tamilnadu Urban Finance and Infrastructure Development Corporation Ltd)
                        </p> 
                    </div>
                </div>
            </div>
            <!-- <div class="col-12">
                <div class="services-details-content">
                    <div class="services-content font-family004">
                        <h3 class="font-family005">Why is it important?</h3>
                        <p><b>Improved urban quality of life :- </b>
                            Live information on the city to the citizens including important events, weather, accidents and emergency notices in times of calamities help people plan accordingly.</p>
                        <p>Deploying a surveillance system integrated with computer vision reduced fatalities like homicide, fires, and road traffic upto 10% (insert evidence). Further, incidents of assault, burglary, auto theft, and robbery could be 40%. The benefits of these metrics is the peace of mind and freedom of movement it provides to its residents.
                        </p>    
                        <p>Get control over city operations by monitoring them through a single dashboard. Allowed the city government to better attend to the citizens grievances.
                        </p>
                        <p>Using ‘citizen app’ and ‘workforce app’ we nearly tripled the share of residents who feel connected to the local government and doubled the share who feel connected to the local community. On the other end of the spectrum, establishing channels for two-way communication between local agencies and the public made the city government more responsive.Increased public safety
                        </p>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</section>
<!-- End Services Details Area -->

